// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_APP_ID,
// };
const firebaseConfig = {
  apiKey: "AIzaSyD1VRLKX27t4bfZR1WaZdl74gU9qR_3lNY",
  authDomain: "assignment-11-authentication.firebaseapp.com",
  projectId: "assignment-11-authentication",
  storageBucket: "assignment-11-authentication.appspot.com",
  messagingSenderId: "1069968238913",
  appId: "1:1069968238913:web:659507ecfc8cd5917b99c0",
};



export default firebaseConfig;
